import {injectDom} from '../components/index';
import LanguageAction from '../reducers/language/action';
import Project from './project';
import Account from './account';
import UiHelper from './uiHelper';
import Services from './services';
import Sprite from './sprite';
import {configUtil} from '../config';
import store from '../reducers';
import authorize from '../services/authorize';

class MBlock {
    constructor(optConfig) {
        optConfig = optConfig ? optConfig : {};
        let config = Object.assign({
            showCopyrightLogo: true
        }, optConfig);
        configUtil.setConfig(config);
        this.project = new Project();
        this.account = new Account();
        this.uiHelper = new UiHelper();
        this.services = new Services();
        this.sprite = new Sprite();
        this.version = '0.4.0';

        let id = ['v', 'i', 'p', 'c', 'o', 'd', 'e'].join('');
        // let id = ['q', 'i', 'n', 'g', 'w', 'a'].join('');
        authorize.setChannelId(id);
    }

    inject (domId) {
        injectDom(domId);
    }

    setLang(lang) {
        store.dispatch(LanguageAction.change(lang));
    }
}

window.MBlock = MBlock;
export default MBlock;